import React from 'react'
import OperacionesPedidos from '../containers/OperacionesPedidos'
import moment from 'moment'

export const COLUMNS_PEDIDO_CAMIONES_EN_PLAYA = [
  {
    name: 'fechaDePedido',
    label: 'Fecha de pedido',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect',
      customBodyRender: f => {
        moment.locale('ar-AR')
        const fecha = moment(f).format('DD/MM/YY HH:mm')
        return <div>{fecha}</div>
      }
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'cantidad',
    label: 'Cantidad',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'restantes',
    label: 'Restan',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'fechaDePedido',
    label: ' ',
    options: {
      print: false,
      filter: false,
      sort: false,
      viewColumns: false,
      customBodyRender: value => {
        return <OperacionesPedidos fecha={value} />
      }
    }
  }

]
export const COLUMNS_PEDIDO_CAMIONES_EN_PLAYA_TO_PRINT = [
  {
    name: 'fechaDePedido',
    label: 'Fecha de pedido',
    width: 70,
    mantenerCase: true
  },
  {
    name: 'cereal',
    label: 'Cereal',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'cantidad',
    label: 'Cantidad',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'restantes',
    label: 'Restan',
    width: 60,
    mantenerCase: true
  }
]
